import * as React from "react";
const SvgCheck = props => <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 3L4.5 8.5L2 6" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgCheck;